import React from 'react';
import { Avatar, Box, ButtonBase, Paper, Typography } from '@mui/material';

export default function SummaryCard({ label, value, accent, tint, icon, onClick, selected, component, to, title }) {
  const actionable = Boolean(onClick || to);
  return (
    <Paper component={component || (onClick ? ButtonBase : 'div')} to={to} onClick={onClick}
      title={title}
      aria-pressed={onClick && selected !== undefined ? selected : undefined}
      sx={{
        p: 1.25, minHeight: 80, width: '100%', height: '100%', minWidth: 0,
        display: 'flex', alignItems: 'center', boxSizing: 'border-box', borderRadius: 2.5,
        background: `linear-gradient(135deg, ${tint} 0%, ${tint}99 100%)`,
        border: `1px solid ${accent}35`, borderTop: `3px solid ${accent}80`,
        color: '#16324f', textDecoration: 'none', textAlign: 'left',
        touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent',
        position: 'relative', overflow: 'hidden', cursor: actionable ? 'pointer' : 'default',
        boxShadow: selected ? `0 0 0 2px ${accent}55` : '0 3px 12px rgba(16,42,67,.04)',
        transition: 'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease',
        '@media (hover: hover) and (pointer: fine)': { '&:hover': actionable ? { transform: 'translateY(-2px)', boxShadow: '0 6px 18px rgba(16,42,67,.08)', borderColor: accent } : {} },
        '&:active': actionable ? { transform: 'scale(.99)' } : {},
        '&:focus-visible, &.Mui-focusVisible': { outline: '3px solid #16324f', outlineOffset: 3 },
        '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover, &:active': { transform: 'none' } },
        '&::after': { content: '""', position: 'absolute', width: 110, height: 110, borderRadius: '50%', bgcolor: 'rgba(255,255,255,.09)', top: -35, right: -25, pointerEvents: 'none' },
      }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: .75, width: '100%', minWidth: 0 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ color: accent, fontWeight: 700, mb: .35, fontSize: '.7rem', lineHeight: 1.3, overflowWrap: 'anywhere' }}>{label}</Typography>
          <Typography sx={{ fontWeight: 900, fontSize: { xs: '1rem', sm: '1.15rem' }, lineHeight: 1.2, overflowWrap: 'anywhere' }}>{value}</Typography>
        </Box>
        <Avatar sx={{ bgcolor: `${accent}20`, color: accent, borderRadius: 2, width: 32, height: 32, flexShrink: 0, fontSize: '.6rem', fontWeight: 900 }}>
          {React.isValidElement(icon) ? React.cloneElement(icon, { sx: { fontSize: 18 } }) : icon}
        </Avatar>
      </Box>
    </Paper>
  );
}
